/* tslint:disable */
/* eslint-disable */
/**
 * SENGO Platform Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.27
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminReportedFeedbackListResponse } from '../model';
// @ts-ignore
import type { EventDetailsResponse } from '../model';
// @ts-ignore
import type { EventStatus } from '../model';
// @ts-ignore
import type { ModerateReportedFeedbackRequest } from '../model';
// @ts-ignore
import type { NoShowCheckInsFilter } from '../model';
// @ts-ignore
import type { PaginatedEventParticipatedResponse } from '../model';
// @ts-ignore
import type { ParticipantSummaryList } from '../model';
/**
 * EventsApi - axios parameter creator
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete an Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvent: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('deleteEvent', 'eventId', eventId)
            const localVarPath = `/admin/event/{eventId}`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all the information available for an Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventDetails: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEventDetails', 'eventId', eventId)
            const localVarPath = `/admin/event/{eventId}`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all the users related to the event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventUsers: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEventUsers', 'eventId', eventId)
            const localVarPath = `/admin/event/{eventId}/users`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get reported feedbacks pending moderation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportedFeedbacksPendingModeration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/feedbacks/reported`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Moderate a reported feedback
         * @param {string} feedbackId 
         * @param {ModerateReportedFeedbackRequest} moderateReportedFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moderateReportedFeedback: async (feedbackId: string, moderateReportedFeedbackRequest: ModerateReportedFeedbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feedbackId' is not null or undefined
            assertParamExists('moderateReportedFeedback', 'feedbackId', feedbackId)
            // verify required parameter 'moderateReportedFeedbackRequest' is not null or undefined
            assertParamExists('moderateReportedFeedback', 'moderateReportedFeedbackRequest', moderateReportedFeedbackRequest)
            const localVarPath = `/admin/feedbacks/{feedbackId}/moderation`
                .replace('{feedbackId}', encodeURIComponent(String(feedbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moderateReportedFeedbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search events, optionally with filters, paginated
         * @param {string} [queryString] Query string to match against event name and description
         * @param {string} [startDate] Starting date (included) to search for events
         * @param {string} [endDate] Ending date (included) to search for events
         * @param {Array<EventStatus>} [status] List of status to filter the search of events
         * @param {number} [page] Page number for pagination
         * @param {number} [pageSize] Number of events per page for pagination
         * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEvents: async (queryString?: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, page?: number, pageSize?: number, noShowCheckIns?: Array<NoShowCheckInsFilter>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (queryString !== undefined) {
                localVarQueryParameter['queryString'] = queryString;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (noShowCheckIns) {
                localVarQueryParameter['noShowCheckIns'] = noShowCheckIns;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete an Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEvent(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEvent(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.deleteEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all the information available for an Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventDetails(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventDetails(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.getEventDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all the users related to the event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventUsers(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParticipantSummaryList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventUsers(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.getEventUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get reported feedbacks pending moderation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportedFeedbacksPendingModeration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminReportedFeedbackListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportedFeedbacksPendingModeration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.getReportedFeedbacksPendingModeration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Moderate a reported feedback
         * @param {string} feedbackId 
         * @param {ModerateReportedFeedbackRequest} moderateReportedFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moderateReportedFeedback(feedbackId: string, moderateReportedFeedbackRequest: ModerateReportedFeedbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moderateReportedFeedback(feedbackId, moderateReportedFeedbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.moderateReportedFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search events, optionally with filters, paginated
         * @param {string} [queryString] Query string to match against event name and description
         * @param {string} [startDate] Starting date (included) to search for events
         * @param {string} [endDate] Ending date (included) to search for events
         * @param {Array<EventStatus>} [status] List of status to filter the search of events
         * @param {number} [page] Page number for pagination
         * @param {number} [pageSize] Number of events per page for pagination
         * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchEvents(queryString?: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, page?: number, pageSize?: number, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedEventParticipatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchEvents(queryString, startDate, endDate, status, page, pageSize, noShowCheckIns, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.searchEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventsApi - factory interface
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete an Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvent(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEvent(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all the information available for an Event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventDetails(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<EventDetailsResponse> {
            return localVarFp.getEventDetails(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all the users related to the event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventUsers(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<ParticipantSummaryList> {
            return localVarFp.getEventUsers(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get reported feedbacks pending moderation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportedFeedbacksPendingModeration(options?: RawAxiosRequestConfig): AxiosPromise<AdminReportedFeedbackListResponse> {
            return localVarFp.getReportedFeedbacksPendingModeration(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Moderate a reported feedback
         * @param {string} feedbackId 
         * @param {ModerateReportedFeedbackRequest} moderateReportedFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moderateReportedFeedback(feedbackId: string, moderateReportedFeedbackRequest: ModerateReportedFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.moderateReportedFeedback(feedbackId, moderateReportedFeedbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search events, optionally with filters, paginated
         * @param {string} [queryString] Query string to match against event name and description
         * @param {string} [startDate] Starting date (included) to search for events
         * @param {string} [endDate] Ending date (included) to search for events
         * @param {Array<EventStatus>} [status] List of status to filter the search of events
         * @param {number} [page] Page number for pagination
         * @param {number} [pageSize] Number of events per page for pagination
         * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEvents(queryString?: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, page?: number, pageSize?: number, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedEventParticipatedResponse> {
            return localVarFp.searchEvents(queryString, startDate, endDate, status, page, pageSize, noShowCheckIns, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventsApi - interface
 */
export interface EventsApiInterface {
    /**
     * 
     * @summary Delete an Event
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEvent(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get all the information available for an Event
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEventDetails(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<EventDetailsResponse>;

    /**
     * 
     * @summary Get all the users related to the event
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEventUsers(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<ParticipantSummaryList>;

    /**
     * 
     * @summary Get reported feedbacks pending moderation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReportedFeedbacksPendingModeration(options?: RawAxiosRequestConfig): AxiosPromise<AdminReportedFeedbackListResponse>;

    /**
     * 
     * @summary Moderate a reported feedback
     * @param {string} feedbackId 
     * @param {ModerateReportedFeedbackRequest} moderateReportedFeedbackRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    moderateReportedFeedback(feedbackId: string, moderateReportedFeedbackRequest: ModerateReportedFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Search events, optionally with filters, paginated
     * @param {string} [queryString] Query string to match against event name and description
     * @param {string} [startDate] Starting date (included) to search for events
     * @param {string} [endDate] Ending date (included) to search for events
     * @param {Array<EventStatus>} [status] List of status to filter the search of events
     * @param {number} [page] Page number for pagination
     * @param {number} [pageSize] Number of events per page for pagination
     * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchEvents(queryString?: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, page?: number, pageSize?: number, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedEventParticipatedResponse>;

}

/**
 * EventsApi - object-oriented interface
 */
export class EventsApi extends BaseAPI implements EventsApiInterface {
    /**
     * 
     * @summary Delete an Event
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteEvent(eventId: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).deleteEvent(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all the information available for an Event
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEventDetails(eventId: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventDetails(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all the users related to the event
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEventUsers(eventId: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventUsers(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get reported feedbacks pending moderation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReportedFeedbacksPendingModeration(options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getReportedFeedbacksPendingModeration(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Moderate a reported feedback
     * @param {string} feedbackId 
     * @param {ModerateReportedFeedbackRequest} moderateReportedFeedbackRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moderateReportedFeedback(feedbackId: string, moderateReportedFeedbackRequest: ModerateReportedFeedbackRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).moderateReportedFeedback(feedbackId, moderateReportedFeedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search events, optionally with filters, paginated
     * @param {string} [queryString] Query string to match against event name and description
     * @param {string} [startDate] Starting date (included) to search for events
     * @param {string} [endDate] Ending date (included) to search for events
     * @param {Array<EventStatus>} [status] List of status to filter the search of events
     * @param {number} [page] Page number for pagination
     * @param {number} [pageSize] Number of events per page for pagination
     * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchEvents(queryString?: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, page?: number, pageSize?: number, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).searchEvents(queryString, startDate, endDate, status, page, pageSize, noShowCheckIns, options).then((request) => request(this.axios, this.basePath));
    }
}

